import React from "react";
import { Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import fp from "lodash/fp";
import { Row, UseRowStateInstanceProps } from "react-table";
import { required } from "validators";
import clsx from "clsx";
import styles from "./table.module.scss";

type Props = Pick<UseRowStateInstanceProps<any>, "setRowState"> & {
	row: Row;
	onRowClick?: (row: { [key: string]: any }) => void;
	handleRowSubmit?: ({
		values,
		row,
		setRowState,
	}: {
		values: { [key: string]: any };
		row: { [key: string]: any };
		setRowState: any;
	}) => any;
};

export const TableRow = ({
	row,
	handleRowSubmit,
	setRowState,
	onRowClick,
}: Props) => {
	const {
		handleSubmit,
		register,
		errors,
		control,
		setValue,
		getValues,
	} = useForm({
		defaultValues: row.values,
	});

	const getField = cell => {
		// That should return different types of fields. E.g. datepicker | input... etc
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		const cellProps = {
			name: cell.column.id,
			defaultValue: cell.value,
			validator: required,
			register,
			setValue,
			getValues,
			control,
			errors,
			className: styles.fixInputMargin,
		};

		if (fp.get("column.Cell.name", cell) !== "defaultRenderer")
			return cell.render("Cell", {
				row,
				cell,
				setRowState,
				cellProps,
			});

		if (row.state.edit && cell.column.editable) return <div />;

		return <span>{cell.value}</span>;
	};

	const editableRowClassName = row.state.edit ? "editableRow" : "";

	return (
		<Form
			{...row.getRowProps()}
			onSubmit={handleSubmit(values =>
				handleRowSubmit?.({ values, row, setRowState }),
			)}
			onClick={() => !row.state.edit && onRowClick?.(row)}
			className={clsx(styles.row, editableRowClassName)}
		>
			{row.cells.map(cell => {
				const column = cell.column as any;
				const classNameCell = column?.classNameCell;

				const cellProps = cell.getCellProps({
					className: clsx(styles.cell, classNameCell),
				});

				return <div {...cellProps}>{getField(cell)}</div>;
			})}
			<input type="submit" hidden />
		</Form>
	);
};
